"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadArticles = loadArticles;
exports.loadArticlesFromCollection = loadArticlesFromCollection;
exports.watchLoadArticles = watchLoadArticles;
exports.watchLoadArticlesFromCollection = watchLoadArticlesFromCollection;
exports["default"] = exports.articlesSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _selectors = _interopRequireDefault(require("../collections/selectors"));

var _selectors2 = require("./selectors");

var _marked = _regeneratorRuntime2.mark(loadArticles),
    _marked2 = _regeneratorRuntime2.mark(loadArticlesFromCollection),
    _marked3 = _regeneratorRuntime2.mark(watchLoadArticles),
    _marked4 = _regeneratorRuntime2.mark(watchLoadArticlesFromCollection);

function loadArticles(api, action) {
  var _action$payload, clientId, skip, fetchMore, language, groups, limit, _yield$api$getArticle, data, meta, articlesData, collections, highlightedArticlesStore, highlightedArticles, highlightedCollection, _highlightedArticles, _yield$api$getArticle2, _yield$api$getArticle3, _data, newData;

  return _regenerator["default"].wrap(function loadArticles$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, clientId = _action$payload.clientId, skip = _action$payload.skip, fetchMore = _action$payload.fetchMore, language = _action$payload.language, groups = _action$payload.groups, limit = _action$payload.limit;
          _context.next = 4;
          return api.getArticles({
            clientId: clientId,
            skip: skip,
            groups: groups,
            limit: limit,
            language: language
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getArticle = _context.sent;
          data = _yield$api$getArticle.data;
          meta = _yield$api$getArticle.meta;
          _context.next = 9;
          return (0, _effects.select)(_selectors2.articlesListDataSelector);

        case 9:
          articlesData = _context.sent;
          _context.next = 12;
          return (0, _effects.select)(_selectors["default"].loadCollectionsDataSelector);

        case 12:
          collections = _context.sent;
          _context.next = 15;
          return (0, _effects.select)(_selectors2.articlesListHighlightedSelector);

        case 15:
          highlightedArticlesStore = _context.sent;
          highlightedArticles = [];

          if (highlightedArticlesStore) {
            _context.next = 28;
            break;
          }

          highlightedCollection = collections.find(function (collection) {
            return collection === null || collection === void 0 ? void 0 : collection.isHighlighted;
          });

          if (!highlightedCollection) {
            _context.next = 26;
            break;
          }

          _context.next = 22;
          return api.getArticlesFromCollection({
            clientId: clientId,
            language: language,
            collectionId: highlightedCollection === null || highlightedCollection === void 0 ? void 0 : highlightedCollection._id,
            limit: 3
          }).then(function (p) {
            return p.request;
          });

        case 22:
          _yield$api$getArticle2 = _context.sent;
          _yield$api$getArticle3 = _yield$api$getArticle2.data;
          _data = _yield$api$getArticle3 === void 0 ? [] : _yield$api$getArticle3;

          (_highlightedArticles = highlightedArticles).push.apply(_highlightedArticles, (0, _toConsumableArray2["default"])(_data));

        case 26:
          _context.next = 29;
          break;

        case 28:
          highlightedArticles = highlightedArticlesStore;

        case 29:
          newData = fetchMore ? [].concat((0, _toConsumableArray2["default"])(articlesData), (0, _toConsumableArray2["default"])(data || [])) : data;
          _context.next = 32;
          return (0, _effects.put)(_actions["default"].loadArticlesSuccess({
            data: newData,
            meta: meta,
            highlighted: highlightedArticles
          }));

        case 32:
          _context.next = 38;
          break;

        case 34:
          _context.prev = 34;
          _context.t0 = _context["catch"](0);
          _context.next = 38;
          return (0, _effects.put)(_actions["default"].loadArticlesError());

        case 38:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 34]]);
}

function loadArticlesFromCollection(api, action) {
  var _action$payload2, collectionId, language, clientId, fetchMore, skip, limit, articlesFromCollectionData, _yield$api$getArticle4, data, meta, newData;

  return _regenerator["default"].wrap(function loadArticlesFromCollection$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, collectionId = _action$payload2.collectionId, language = _action$payload2.language, clientId = _action$payload2.clientId, fetchMore = _action$payload2.fetchMore, skip = _action$payload2.skip, limit = _action$payload2.limit;
          _context2.next = 4;
          return (0, _effects.select)(_selectors2.articlesFromCollectionDataSelector);

        case 4:
          articlesFromCollectionData = _context2.sent;
          _context2.next = 7;
          return api.getArticlesFromCollection({
            clientId: clientId,
            language: language,
            collectionId: collectionId,
            skip: skip,
            limit: limit
          }).then(function (p) {
            return p.request;
          });

        case 7:
          _yield$api$getArticle4 = _context2.sent;
          data = _yield$api$getArticle4.data;
          meta = _yield$api$getArticle4.meta;
          newData = fetchMore ? [].concat((0, _toConsumableArray2["default"])(articlesFromCollectionData), (0, _toConsumableArray2["default"])(data || [])) : data;
          _context2.next = 13;
          return (0, _effects.put)(_actions["default"].loadArticlesFromCollectionSuccess({
            data: newData,
            meta: meta
          }));

        case 13:
          _context2.next = 19;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 19;
          return (0, _effects.put)(_actions["default"].loadArticlesFromCollectionError());

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 15]]);
}

function watchLoadArticles(api) {
  return _regenerator["default"].wrap(function watchLoadArticles$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadArticles), loadArticles, api);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function watchLoadArticlesFromCollection(api) {
  return _regenerator["default"].wrap(function watchLoadArticlesFromCollection$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadArticlesFromCollection), loadArticlesFromCollection, api);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

var articlesSagas = function articlesSagas(api) {
  return [(0, _effects.fork)(watchLoadArticles, api), (0, _effects.fork)(watchLoadArticlesFromCollection, api)];
};

exports.articlesSagas = articlesSagas;
var _default = articlesSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map